<template>
  <button
    :class="{ loading: updateInProgress }"
    type="button"
    v-confirm-click="{ onConfirm: handleClick, confirmMessage: confirmMessage }"
  >
    <slot></slot>
  </button>
</template>

<script>
// @flow
export default {
  name: 'loading-confirm-button',
  props: ['onClick', 'confirmMessage'],

  data() {
    return {
      updateInProgress: false
    }
  },

  methods: {
    handleClick() {
      this.updateInProgress = true

      const promise = this.onClick()
      if (promise && promise.then && typeof promise.then === 'function') {
        promise
          .then(() => {
            this.updateInProgress = false
          })
          .catch(() => {
            this.updateInProgress = false
          })
      } else {
        this.updateInProgress = false
      }
    }
  }
}
</script>
